// Generate a random session ID
export const generateSessionId = () => {
  return 'session_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
};

// Get or create session ID for a specific source
export const getSessionId = (source) => {
  const key = `sessionId_${source}`;
  let sessionId = localStorage.getItem(key);
  
  if (!sessionId) {
    sessionId = generateSessionId();
    localStorage.setItem(key, sessionId);
  }
  
  return sessionId;
};

// Clear session ID for a specific source (used when resetting)
export const clearSessionId = (source) => {
  const key = `sessionId_${source}`;
  const sessionId = localStorage.getItem(key);
  
  // Clear the session ID
  localStorage.removeItem(key);
  
  // Also clear messages for this source and session
  if (sessionId) {
    localStorage.removeItem(`messages_${source}_${sessionId}`);
  }
};

// Clear all sessions and messages
export const clearAllSessions = () => {
  const sources = ['JE', 'JB', 'EN'];
  sources.forEach(source => {
    clearSessionId(source);
  });
};

// Get message count for a specific source (for UI indicators)
export const getMessageCount = (source) => {
  const sessionId = getSessionId(source);
  const savedMessages = localStorage.getItem(`messages_${source}_${sessionId}`);
  if (savedMessages) {
    try {
      const messages = JSON.parse(savedMessages);
      return messages.length;
    } catch (error) {
      return 0;
    }
  }
  return 0;
}; 